import DataTable from "datatables.net-bs5";
import React, { useEffect, useRef, useState } from "react";
import { dummyImage } from "../../../images";
import { Pagination } from "antd";
import PermissionControlledCard from "../../common/PermissionControlledCard";

const AreaTableModal = ({ show, data, title, categoryName, onCancel, loading = false, permission }) => {
	//   const offcanvasRef = useRef();
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 5;

	const totalPages = Math.ceil(data.length / itemsPerPage);
	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
	const handlePageChange = (pageNumber) => {
		if (pageNumber < 1 || pageNumber > totalPages) return;
		setCurrentPage(pageNumber);
	};
	const csvSafe = (value) => {
		if (value === null || value === undefined) return "";

		const stringValue = String(value).replace(/"/g, '""'); // escape quotes
		return `"${stringValue}"`; // wrap in quotes
	};

	const downloadCSV = () => {
		if (!data || data.length === 0) return;

		const headers = [
			"Name",
			"ASIN",
			"SKU",
			"Net Sales",
			"Actual Units",
			"Refunded Units",
			"Cancelled Units",
			"Replacement Units"
		];

		const rows = data.map(item => [
			csvSafe(item?.name),
			csvSafe(item?.asin),
			csvSafe(item?.sku),
			csvSafe(item?.net_sales),
			csvSafe(item?.actual_units),
			csvSafe(item?.refunded_units),
			csvSafe(item?.cancelled_units),
			csvSafe(item?.replacement_units)
		]);

		const csvContent = [
			headers.map(csvSafe).join(","), // header row
			...rows.map(row => row.join(","))
		].join("\n");

		const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
		const url = URL.createObjectURL(blob);

		const link = document.createElement("a");
		link.href = url;
		link.download = `${categoryName || "data"}-${title || "report"}.csv`;

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};



	return (
		<>
			{/* </PermissionControlledCard> */}
			{/* <button className="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling">Enable body scrolling</button> */}
			<div className={`offcanvas area-table-model offcanvas-end ${show ? 'show' : ''}`} data-bs-scroll="true" data-bs-backdrop="false" tabIndex="-1" id="offcanvasScrolling" aria-labelledby="offcanvasScrollingLabel">
				<PermissionControlledCard permission={permission} colClass='mb-3'>
					<div className="offcanvas-header pb-0">
						<h5 className="offcanvas-title kpi-heading" id="offcanvasScrollingLabel">{categoryName} - {title}</h5>
						<button
							className="btn"
							onClick={downloadCSV}
							disabled={!data?.length}
						>
							<i className="bi bi-download"></i>
						</button>
						<button type="button" className="btn-close btn" data-bs-dismiss="offcanvas" aria-label="Close" onClick={onCancel}></button>
						{/* <div className="offcanvas-header pb-0 d-flex justify-content-between align-items-center">
							<h5 className="offcanvas-title kpi-heading">
								{categoryName} - {title}
							</h5>

							<div className="d-flex gap-2">
								<button
									className="btn"
									onClick={downloadCSV}
									disabled={!data?.length}
								>
  								  <i className="bi bi-download"></i>
								</button>
							<button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" onClick={onCancel}></button>
							</div>
						</div> */}
					</div>
					<div className="offcanvas-body py-0 hide-scrollbar">
						<div className="container py-4">
							{/* Cards */}
							{currentItems.map((product, index) => (
								<div className="card mb-3 area-card border-0" key={index}>
									<div className="card-body">
										<div className="d-flex">
											<img
												src={product?.image || dummyImage}
												alt="Product"
												className="me-3 rounded"
												style={{ width: '60px', height: '60px', objectFit: 'cover' }}
											/>

											<div>
												<p className="mb-1 area-table-name truncate-2-lines">{`(1): ${product?.name}`}</p>
												<p className="mb-0 area-table-name">
													<strong>ASIN:</strong> {product?.asin} &nbsp;| &nbsp;
													<strong>SKU:</strong> {product?.sku}
												</p>
											</div>
										</div>

										<div className="d-flex justify-content-between align-items-center mt-3 flex-wrap text-center">
											<div>
												<div className="area-table-name">{product.net_sales}</div>
												<small className="area-table-name">Net Sales</small>
											</div>
											<div>
												<div className="area-table-name">{product?.actual_units}</div>
												<small className="area-table-name">Actual</small>
											</div>
											<div>
												<div className="area-table-name">{product?.refunded_units}</div>
												<small className="area-table-name">Refunded</small>
											</div>
											<div>
												<div className="area-table-name">{product?.cancelled_units}</div>
												<small className="area-table-name">Canceled</small>
											</div>
											<div>
												<div className="area-table-name">{product?.replacement_units}</div>
												<small className="area-table-name">Replaced</small>
											</div>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
					<div style={{ textAlign: 'center', marginTop: '20px', position: 'absolute', bottom: '0', background: 'var(--white-color)' }}>
						<Pagination
							current={currentPage}
							pageSize={itemsPerPage}
							total={data.length}
							onChange={(page) => handlePageChange(page)}
							showSizeChanger={false}
						/>
					</div>
				</PermissionControlledCard>
			</div>
		</>
	)
}
export default AreaTableModal;